module.exports = __webpack_public_path__ + "static/media/mlVerticalHAV.1f6e28b7.png";